import { MediaDetectionProperties, MetadataSerialization } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-media-detection-properties',
	templateUrl: './media-detection-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaDetectionPropertiesComponent extends BaseAuthoringPropertiesComponent<MediaDetectionProperties> {
	
	public propertyConstructor: MetadataSerialization.Deserializable<MediaDetectionProperties> = MediaDetectionProperties;
	
}
